import { render, staticRenderFns } from "./VNavLink.vue?vue&type=template&id=19e63998&"
import script from "./VNavLink.vue?vue&type=script&lang=js&"
export * from "./VNavLink.vue?vue&type=script&lang=js&"
import style0 from "./VNavLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports